/**
 * See RMA ADM A00530
 */
export const RmaSubclassCodes = {
  NoSubclassSpecified: '997',
  // below are not used for livestock
  SmallKabuli: '025',
  LargeKabuli: '219',
} as const;

export type RmaSubclassCodes =
  (typeof RmaSubclassCodes)[keyof typeof RmaSubclassCodes];
